import { render, staticRenderFns } from "./CampaignsContacts.vue?vue&type=template&id=46d06ac4&lang=pug"
import script from "./CampaignsContacts.vue?vue&type=script&lang=js"
export * from "./CampaignsContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports